module.exports = __webpack_public_path__ + "static/media/apply_promo.3ef9bded.svg";